import script from "./PaperSelectDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PaperSelectDialog.vue?vue&type=script&setup=true&lang=js"

import "./PaperSelectDialog.vue?vue&type=style&index=0&id=88d9701e&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88d9701e"]])

export default __exports__